<mat-card>
  <form [formGroup]=""> <div fxLayout="column" fxLayoutGap="20px">

    <div *ngIf="profile?.userId" fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="(userPermissions | async).marketing.write"
              (click)="modify()" mat-stroked-button color="primary">
        <mat-icon>create</mat-icon> <span> Edytuj</span>
      </button>
      <button *ngIf="(userPermissions | async).marketing.delete"
              (click)="delete()" mat-stroked-button color="warn">
        <mat-icon>delete</mat-icon> <span> Usuń</span>
      </button>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start">

      <div fxFlex="100" fxLayout="row" fxLayoutGap="20px">

        <mat-card fxFlex="50">
          <h3>Dane</h3>

          <div fxLayout="column" fxLayoutGap="10px">
            <div fxLayout="row" fxLayoutGap="10px">
              <app-detail fxFlex="100" header="Nazwa pola"
                          [value]="additionalFieldObject?.fieldName">
              </app-detail>

              <app-detail fxFlex="100" header="Typ pola"
                          [value]="additionalFieldObject?.fieldType?.name">
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="10px">
              <app-detail-bool header="Aktywne"
                               [value]="additionalFieldObject?.active">
              </app-detail-bool>
            </div>

          </div>
        </mat-card>

      </div>

    </div>
  </div>
  </form>
</mat-card>
